import { render, staticRenderFns } from "./AccomodationReservationsList.vue?vue&type=template&id=3bc0f8c0&"
import script from "./AccomodationReservationsList.vue?vue&type=script&lang=js&"
export * from "./AccomodationReservationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports